module.exports = __webpack_public_path__ + "img/per.426b8318.png";